<template>
  <div class="cr-flex cr-justify-between gap-1 cr-align-center cr-w-100 cr-min-w-0">
    <div class="cr-flex cr-align-center gap-2 cr-min-w-0">
      <BaseButton
        v-if="showBackButton"
        emphasis="none"
        icon="fa-arrow-left"
        icon-font-size="16px"
        theme="mono"
        @click="$emit('click:back')"
      />
      <BaseIcon
        v-else-if="!showHomeButton"
        color="var(--grape-jelly-700)"
        font-size="16px"
        icon="fa-solid fa-sparkles"
      />
      <div class="cr-flex cr-w-100 cr-min-w-0">
        <span
          class="crafty-copilot__drawer__header title-s-medium cr-font-poppins cr-truncate"
          :title="text"
        >
          {{ text }}
        </span>
      </div>
    </div>
    <div class="cr-flex gap-4">
      <BaseTooltip
        v-if="showHomeButton"
        content="Back to Home"
        :placement="'top'"
      >
        <BaseButton
          class="pepper-700"
          emphasis="none"
          icon="fa-regular fa-home"
          icon-font-size="16px"
          @click="$emit('click:home')"
        />
      </BaseTooltip>
      <BaseTooltip
        v-if="showHistoryButton"
        content="Chat History"
        :placement="'top'"
      >
        <BaseButton
          class="pepper-700"
          data-testid="crafty-copilot-view-history-button"
          emphasis="none"
          icon="far fa-clock"
          icon-font-size="16px"
          theme="mono"
          @click="$emit('click:history')"
        />
      </BaseTooltip>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import BaseButton from './BaseButton.vue'
import BaseIcon from './BaseIcon.vue'
import BaseTooltip from './BaseTooltip.vue'

export default defineComponent({
  name: 'CraftyCopilotHeader',
  components: {
    BaseButton,
    BaseIcon,
    BaseTooltip,
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
    showHomeButton: {
      type: Boolean,
      default: false,
    },
    showHistoryButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Crafty Copilot',
    },
  },
  emits: ['click:home', 'click:back', 'click:history'],
})
</script>
